var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { "data-vv-scope": "change-owner-form" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.save($event)
        }
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c("list-user", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              ref: "propietario",
              staticClass: "w-100",
              attrs: {
                autocomplete: "",
                name: "propietario",
                placeholder: "Elija un nuevo propietario",
                danger: _vm.errors.has("change-owner-form.propietario"),
                "danger-text": _vm.errors.first("change-owner-form.propietario")
              },
              on: { input: _vm.getUserId },
              model: {
                value: _vm.newOwner,
                callback: function($$v) {
                  _vm.newOwner = $$v
                },
                expression: "newOwner"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "m-top-20 d-flex justify-end" },
        [
          _c(
            "vs-button",
            {
              staticClass: "mt-5 ml-3",
              attrs: { color: "primary", type: "border" },
              on: {
                click: function($event) {
                  return _vm.save()
                }
              }
            },
            [
              _vm._v(" Editar "),
              _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                staticClass: "spinner-border spinner-border-sm text-white"
              })
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }